import { render, staticRenderFns } from "./ThumbnailSlotSmallHorizontal.vue?vue&type=template&id=6db09dbc"
import script from "./ThumbnailSlotSmallHorizontal.vue?vue&type=script&lang=js"
export * from "./ThumbnailSlotSmallHorizontal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports